export const macrosChartTypes = ['GOALS', 'BASELINE'];
